import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import DOMPurify from 'dompurify'
import axios from '../../api/axios'
import toast from 'react-hot-toast'

export default function Policy() {
   const [privacy, setPrivacy] = useState('')

   const getContents = async () => {
      try {
         await axios
            .post(`getContents`)
            .then((result) => {
               setPrivacy(DOMPurify.sanitize(result.data.privacy))
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      }
   }

   useEffect(() => {
      getContents()
   }, [])

   return (
      <Box
         sx={{
            flexGrow: 1,
            p: 3,
            bgcolor: 'rgb(229, 229, 229)',
            overflowY: 'overlay',
         }}
      >
         <Box sx={{ mt: '80px' }}>
            <h2 style={{ color: '#FA870B', margin: '0px' }}>Privacy Policy</h2>
         </Box>
         <Box
            sx={{
               mt: '10px',
               borderTop: '5px solid #FA870B',
               bgcolor: 'white',
               borderBottomRightRadius: '5px',
               borderBottomLeftRadius: '5px',
               overflow: 'auto',
               p: '10px',
               height: '60vh',
            }}
            dangerouslySetInnerHTML={{ __html: privacy }}
         />
      </Box>
   )
}
